export const getSelectedPlan = (state) => {
   return state.selectedPlan?.compania?.id_compania;
};

export const getPlanCultivo = (state) => {
   return state.planes;
};

export const provinciasCotizablesOptions = (state) =>
   (state.provinciasCotizables || []).map((provincia) => ({
      ...provincia,
      label: provincia.nombre,
      value: provincia.id_provincia,
   }));

export const departamentosCotizablesOptions =
   (state) => (id_provincia) => {
      const list = state.departamentosCotizables?.[id_provincia] || [];
      return list.map((d) => ({
         ...d,
         label: d.descripcion,
         value: d.id_departamento,
      }));
   };
